'use strict';

/**
 * Detect anchors as they are scrolled into viewport and mark
 * links that target it.
 *
 * @param links Links to mark active or inactive when their targets enter and leave viewport.
 * @param activeClassName Class to add to active links; if this is a callback, it is called with true or false
 *  wether this is active or inactive.
 */
export default function init(links, activeClassName = 'active') {

    const targetLinks = new Map();

    const targetSelector =
        Array.prototype.map.call(links, function (link) {
            return link.getAttribute('href');
        })
            .filter(function (href) {
                return /^#/.test(href);
            })
            .join(',');
    
    if (!targetSelector) {
        return;
    }

    const targets = Array.prototype.slice.call(document.querySelectorAll(targetSelector)).sort(function (a, b) {
        return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });

    targets.forEach(function (target) {
        targetLinks.set(target, getLinksForTarget(target));
    });

    let activeTarget = null;
    let timeoutId = null;

    window.addEventListener('scroll', function () {
        if (timeoutId) {
            return;
        }
        updateActive();

        // wait before another update
        timeoutId = setTimeout(function () {
            updateActive();
            clearTimeout(timeoutId);
            timeoutId = null;
        }, 200);
    }, {passive: true});

    updateActive();

    function getLinksForTarget(target) {
        var id = target.getAttribute('id');
        return Array.prototype.filter.call(links, function (link) {
            return link.getAttribute('href') === ('#' + id);
        });
    }

    function updateActive() {

        // update active target
        let newTarget = activeTarget;
        const threshold = window.innerHeight * .4;
        // console.log('threshold', threshold);
        for (let i = 0; i < targets.length; ++i) {
            const target = targets[i];
            const top = target.getBoundingClientRect().top;
            // console.log(target.getAttribute('id'), top);
            if (top < threshold) {
                newTarget = target;
            }
        }

        // console.log(newTarget.id, activeTarget ? activeTarget.id : null);

        if (newTarget === activeTarget) {
            return;
        }

        activeTarget = newTarget;

        // toggle state
        targetLinks.forEach(function (links, target) {
            links.forEach(function (link) {
                link.classList.toggle(activeClassName, target === activeTarget);
            });
        });
    }
}
